import { DataFetchingClient, DataFetchingClientProvider } from 'data-fetching-client';
import { jsx as _jsx } from "react/jsx-runtime";
const client = new DataFetchingClient();
export const ProvideDataFetchingClient = ({
  children
}) => /*#__PURE__*/_jsx(DataFetchingClientProvider, {
  client: client,
  children: children
});